module.exports = __webpack_public_path__ + "ae04c2ce5225201a02e5bb568ff99b93.pdf";